import React, { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import CenteredAuth from 'dashboard/layouts/auth/types/Centered';
import { API } from 'utilities/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = () => {
    if (!email) return;
    setBusy(true);
    // `API.forgotPassword` never existed. Because the call was guarded with a
    // ternary, the missing method fell through to `Promise.resolve()` and the
    // user was told their reset email was on the way while nothing was sent —
    // a silent failure on the one flow someone uses when already locked out.
    // The real method is `sendResetPassword` → POST auth/sendresetPassword.
    API.sendResetPassword({ email_address: email })
      .then(() => toast.success('Check your email for a reset link.'))
      .catch((err) => toast.error(err?.message || 'Failed to send reset link'))
      .finally(() => setBusy(false));
  };

  return (
    <CenteredAuth
      image='linear-gradient(135deg, #868CFF 0%, #4318FF 100%)'
      cardTop={{ base: '140px', md: '24vh' }}
      cardBottom={{ base: '50px', lg: 'auto' }}
    >
      <Stack
        direction='column'
        sx={{
          width: '100%',
          maxWidth: 'max-content',
          mr: 'auto',
          height: '100%',
          alignItems: 'flex-start',
          justifyContent: 'center',
          px: { xs: '25px', md: 0 },
        }}
      >
        <Box mr='auto' mb='34px'>
          <Typography variant='h3' fontSize={{ xs: '1.875rem', md: '36px' }} mb='16px'>
            Forgot your password?
          </Typography>
          <Typography
            color='text.secondary'
            sx={{ width: { xs: '100%', lg: '456px' }, maxWidth: '100%' }}
          >
            No problem. Just let us know your email address and we'll email you a password reset link
            that will allow you to choose a new one.
          </Typography>
        </Box>
        <Box sx={{ width: { xs: '100%', lg: '456px' }, maxWidth: '100%', mb: { xs: '20px', md: 'auto' } }}>
          <TextField
            size='small'
            required
            type='email'
            label='Email'
            placeholder='you@yourcompany.com'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            sx={{ mb: '24px' }}
          />
          <Button
            variant='contained'
            fullWidth
            onClick={submit}
            disabled={busy || !email}
            sx={{ height: '50px', mb: '24px' }}
          >
            {busy ? 'Sending…' : 'Email password reset link'}
          </Button>
        </Box>
      </Stack>
    </CenteredAuth>
  );
}
